module.exports = __webpack_public_path__ + "static/img/电话-3.270b4bcb.png";